import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Box,
  Typography,
  Avatar,
  useTheme,
  Button,
  Paper,
  Divider,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { FAKE_STRATEGISTS } from "./strategistsData";

/**
 * StrategistDetail Component
 * Displays full detailed information about a strategist
 */
const Strategist = () => {
  const { strategistId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  
  const strategist = FAKE_STRATEGISTS[strategistId] || FAKE_STRATEGISTS["strategist_1"];

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(-1)}
        sx={{ mb: 4, fontSize: '1.1rem' }}
      >
        Back
      </Button>

      <Paper elevation={3} sx={{ p: 6, borderRadius: 2 }}>
        {/* Header with Avatar */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, mb: 5 }}>
          <Avatar
            sx={{ width: 160, height: 160, bgcolor: 'primary.main' }}
          >
            <AccountCircleIcon sx={{ fontSize: 110 }} />
          </Avatar>
          <Box>
            <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
              {strategist?.name}
            </Typography>
            <Typography variant="h5" color="text.secondary" sx={{ mb: 1, fontWeight: 500 }}>
              {strategist?.title}
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 500 }}>
              {strategist?.experience} of experience
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ my: 4 }} />

        {/* Biography Section */}
        <Box sx={{ mb: 5 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>
            Biography
          </Typography>
          <Typography variant="h6" sx={{ lineHeight: 1.8, color: 'text.secondary', fontSize: '1.1rem' }}>
            {strategist?.bio}
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        {/* Expertise Section */}
        <Box sx={{ mb: 5 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>
            Expertise
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            {strategist?.expertise.map((exp) => (
              <Box
                key={exp}
                sx={{
                  padding: '12px 24px',
                  borderRadius: '20px',
                  backgroundColor: theme.palette.primary.light,
                  color: 'white',
                  fontSize: '1.05rem',
                  fontWeight: 700,
                }}
              >
                {exp}
              </Box>
            ))}
          </Box>
        </Box>

        <Divider sx={{ my: 4 }} />

        {/* Contact Section */}
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>
            Contact Information
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="h6" sx={{ fontSize: '1.1rem' }}>
              <strong>Email:</strong> {strategist?.email}
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default Strategist;
